import { history } from "../../src/index";

import * as types from '../constants/meetingdetails';
import * as toasterTypes from '../constants/ActionTypes';
import * as meetingdetailsApi from '../api/meetingdetails';

export function resetMeeting() {
    // console.log("resetCustomer action call");
    return dispatch => {
        dispatch({ type: types.FETCH_MEETING_RESET });
    }
}

export function setMeetingDetails(data) {
    // console.log("getMeetingDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_MEETING_REQUEST_COMPLETED, data: data });
    }
}

export function getMeetingDetails(id) {
    // console.log("getMeetingDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_MEETING_REQUEST });
        meetingdetailsApi.getMeeting(id)
            .then(function (response) {
                // console.log("getMeetingDetails", response)
                dispatch({ type: types.FETCH_MEETING_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getMeetingDetails Error", err)
                dispatch({ type: types.FETCH_MEETING_REQUEST_ERROR });
            });
    }
}

export function getMeetingMinutesDetails(id) {
    // console.log("getMeetingDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_MEETING_REQUEST });
        meetingdetailsApi.getMeetingMinutes(id)
            .then(function (response) {
                // console.log("getMeetingDetails", response)
                dispatch({ type: types.FETCH_MEETING_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getMeetingDetails Error", err)
                dispatch({ type: types.FETCH_MEETING_REQUEST_ERROR });
            });
    }
}

export function lookupMeetingList(id) {
    // console.log("lookupMeetingList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_SWITCH_MEETING_LIST_REQUEST });
        meetingdetailsApi.lookupMeetingList(id)
            .then(function (response) {
                // console.log("lookupMeetingList", response)
                dispatch({ type: types.FETCH_SWITCH_MEETING_LIST_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("lookupMeetingList Error", err)
                dispatch({ type: types.FETCH_SWITCH_MEETING_LIST_REQUEST_ERROR });
            });
    }
}

export function getMeetingDetailsList(committee_id) {
    // console.log("getMeetingDetailsList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_MEETING_LIST_REQUEST });
        meetingdetailsApi.getMeetingList(committee_id)
            .then(function (response) {
                // console.log("getMeetingDetailsList", response)
                dispatch({ type: types.FETCH_MEETING_LIST_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getMeetingDetailsList Error", err)
                dispatch({ type: types.FETCH_MEETING_LIST_REQUEST_ERROR });
            });
    }
}

export function addMeetingDetails(objModel) {
    // console.log("addMeetingDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_MEETING_REQUEST });
        meetingdetailsApi.addMeeting(objModel)
            .then(function (response) {
                // console.log("addMeetingDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_MEETING_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Saved Successfully" });
                    history.push('/meeting/meeting-list/' + objModel.committee_id);
                }
                dispatch({ type: types.ADD_MEETING_RESET });
            })
            .catch(function (err) {
                // console.log("addMeetingDetails action err", err)
                dispatch({ type: types.ADD_MEETING_REQUEST_ERROR });
            });
    }
}

export function updateMeetingDetails(objModel) {
    // console.log("updateMeetingDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_MEETING_REQUEST });
        meetingdetailsApi.updateMeeting(objModel)
            .then(function (response) {
                // console.log("updateMeetingDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_MEETING_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                    history.push('/meeting/meeting-list/' + objModel.under_committee);
                }
                dispatch({ type: types.ADD_MEETING_RESET });
            })
            .catch(function (err) {
                // console.log("updateMeetingDetails action err", err)
                dispatch({ type: types.ADD_MEETING_REQUEST_ERROR });
            });
    }
}

export function updateMeetingStatusDetails(id, status) {
    // console.log("updateMeetingStatus action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_MEETING_REQUEST });
        meetingdetailsApi.updateMeetingStatus(id, status)
            .then(function (response) {
                // console.log("updateMeetingStatus action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_MEETING_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                    history.push('/meeting/meeting-list');
                }
                dispatch({ type: types.ADD_MEETING_RESET });
            })
            .catch(function (err) {
                // console.log("updateMeetingStatus action err", err)
                dispatch({ type: types.ADD_MEETING_REQUEST_ERROR });
            });
    }
}

export function deleteMeetingDetails(id) {
    // console.log("deleteMeetingDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_MEETING_REQUEST });
        meetingdetailsApi.deleteMeeting(id, status)
            .then(function (response) {
                // console.log("deleteMeetingDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_MEETING_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Deleted Successfully" });
                    history.push('/meeting/meeting-list');
                }
                dispatch({ type: types.ADD_MEETING_RESET });
            })
            .catch(function (err) {
                // console.log("deleteMeetingDetails action err", err)
                dispatch({ type: types.ADD_MEETING_REQUEST_ERROR });
            });
    }
}

export function archiveMeetingDetails(id) {
    // console.log("archiveMeetingDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_MEETING_REQUEST });
        meetingdetailsApi.archiveMeeting(id, status)
            .then(function (response) {
                // console.log("archiveMeetingDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_MEETING_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Archived Successfully" });
                    history.push('/meeting/meeting-list');
                }
                dispatch({ type: types.ADD_MEETING_RESET });
            })
            .catch(function (err) {
                // console.log("archiveMeetingDetails action err", err)
                dispatch({ type: types.ADD_MEETING_REQUEST_ERROR });
            });
    }
}

export function sendMeetingNotification(notificationData) {
    // console.log("updateMeetingStatus action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_MEETING_REQUEST });
        console.log("notification:", notificationData);
        meetingdetailsApi.sendMeetingNotification(notificationData)
            .then(function (response) {
                // console.log("updateMeetingStatus action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_MEETING_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Notification sent Successfully" });
                    history.push('/meeting/meeting-list');
                }
                dispatch({ type: types.ADD_MEETING_RESET });
            })
            .catch(function (err) {
                // console.log("updateMeetingStatus action err", err)
                dispatch({ type: types.ADD_MEETING_REQUEST_ERROR });
            });
    }
}


export function addMeetingMinutesFile(objModel) {
    // console.log("addMeetingDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_MEETING_MINUTES_FILE_REQUEST });
        meetingdetailsApi.addMeetingMinutesFile(objModel)
            .then(function (response) {
                // console.log("addMeetingDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_MEETING_MINUTES_FILE_REQUEST_COMPLETED });
                    //dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Saved Successfully" });
                    // history.push('/meeting/meeting-list/'+objModel.committee_id);
                }
                dispatch({ type: types.ADD_MEETING_RESET });
            })
            .catch(function (err) {
                // console.log("addMeetingDetails action err", err)
                dispatch({ type: types.ADD_MEETING_MINUTES_FILE_REQUEST_ERROR });
            });
    }
}

export function sendMMNotifyEmail(id) {
    console.log("sendMMNotifyEmail action call",id);
    return dispatch => {
        dispatch({ type: types.SEND_MEETING_MINUTES_NOTIFY_REQUEST });
        meetingdetailsApi.sendMMNotifyEmail(id)
            .then(function (response) {
                // console.log("addMeetingDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.SEND_MEETING_MINUTES_NOTIFY_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Notification sent Successfully" });
                    history.push('/meeting/add-meeting/' + id);
                }
                dispatch({ type: types.ADD_MEETING_RESET });
            })
            .catch(function (err) {
                // console.log("addMeetingDetails action err", err)
                dispatch({ type: types.SEND_MEETING_MINUTES_NOTIFY_REQUEST_ERROR });
            });
    }
}

export function updateMeetingMinutesFileDetails(id, objModel) {
    // console.log("updateFileDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.UPDATE_MM_FILE_REQUEST });
        meetingdetailsApi.updateMeetingMinutesFile(id, objModel)
            .then(function (response) {
                // console.log("updateFileDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.UPDATE_MM_FILE_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                    history.push('/meeting/add-meeting/' + id);
                }
            })
            .catch(function (err) {
                // console.log("updateFileDetails action err", err)
                dispatch({ type: types.UPDATE_MM_FILE_REQUEST_ERROR });
            });
    }
}

export function deleteMeetingMinutesFileDetails(objModel, meetingId) {
    // console.log("updateAgendaItemDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.DELETE_MM_FILE_REQUEST });
        meetingdetailsApi.deleteMeetingMinutesFile(objModel)
            .then(function (response) {
                // console.log("updateAgendaItemDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.DELETE_MM_FILE_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Deleted Successfully" });
                    history.push('/meeting/add-meeting/' + meetingId);
                }
            })
            .catch(function (err) {
                // console.log("updateAgendaItemDetails action err", err)
                dispatch({ type: types.DELETE_MM_FILE_REQUEST_ERROR });
            });
    }
}


// WEBPACK FOOTER //
// ./actions/meetingdetails.js